import React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import GroupedView from '../../common/GroupedView';
import Odd from '../../common/Odd';
import { GROUPED_VIEW_MARKETS } from '../../data/constants';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { getBetDescription } from '../../data/utils/getBetDescription';
import { getNumberOfColsMobile } from '../../data/utils/getNumberOfColsMobile';
import { PrematchContext } from '../Prematch';

function Match(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);

    function handleClickHref(e){
        e.preventDefault();
        prematchContext.openMatch(match);
    }

    function handleClickHrefLink(e){
        //e.preventDefault();
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            prematchContext.openMatch(match);
        }else{
            appContext.setHandleOpenFromPath(true);
            prematchContext.openMatch(match);
        }
    }

    // If the compact view is enabled the main bet group must always be shown, even if odds are all locked.
    // If the expanded view is enabled, we only show the bets whose odds aren't all null/locked.
    const match = props.match;
    const bets = match.bets
    let betsToRender = null;
    if (props.expanded) {
        betsToRender = bets.filter(bet => bet.hasOdds);
    } else if (props.bet) {
        betsToRender = [bets.find(bet => bet.id === props.bet.id && bet.handicap == props.bet.handicap)];
        if (betsToRender[0] === undefined) {
            const bet = bets.find(bet => bet.id === props.bet.id);
            if (bet !== undefined) {
                betsToRender = [bet];
            } else {
                betsToRender = [bets[0]];
            }
        }
    } else {
        betsToRender = [bets[0]];
    }

    const relativeMatchPath = useAbsolutePath(match.urlPath,null,match.urlPathSeo,true);
    const noFollow = isSeoSettingsNoFollow(match.urlPathSeoSettings);
    
    if (betsToRender.length === 1 && GROUPED_VIEW_MARKETS.includes(betsToRender[0].cs)) {
        return <GroupedView match={match} bet={betsToRender[0]} />;
    }

    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            {(match.urlPath || match.urlPathSeo)?
            <Link to={encodeURI(relativeMatchPath) } className="info-avvenimento" onClick={handleClickHrefLink.bind(this)} {...(noFollow ? {rel: 'nofollow'}:{})} >
                <div className="nome-avvenimento">
                    {props.showTournamentDesc &&
                        <span className="text-small tournament-desc">{match.tournamentDesc}</span>
                    }
                    <span className="text-small">{match.team1}</span>
                    <span className="text-small">{match.team2}</span>
                </div>
                <span className="ora-avvenimento text-small push-right">{match.time}</span>
                <span className="ora-avvenimento text-small">(+{match.plus})</span>
                <div className="arrow-container arrow-container-small">
                    <span className="arrow arrow-right"></span>
                </div>
            </Link>
            :
            <a className="info-avvenimento" onClick={handleClickHref.bind(this)}>
                <div className="nome-avvenimento">
                    {props.showTournamentDesc &&
                        <span className="text-small tournament-desc">{match.tournamentDesc}</span>
                    }
                    <span className="text-small">{match.team1}</span>
                    <span className="text-small">{match.team2}</span>
                </div>
                <span className="ora-avvenimento text-small push-right">{match.time}</span>
                <span className="ora-avvenimento text-small">(+{match.plus})</span>
                <div className="arrow-container arrow-container-small">
                    <span className="arrow arrow-right"></span>
                </div>
            </a>
            }
            {betsToRender.map((bet, i) => {
                return (
                    <React.Fragment key={i}>
                        {props.expanded &&
                            <div className="label-desc-scom-vista-estesa">{getBetDescription(bet, true)}</div>
                        }
                        <div className={"esiti-container grid-columns-" + getNumberOfColsMobile(bet.odds.length)}>
                            {bet.odds.map((odd, i) => {
                                return <Odd key={i} {...odd} />;
                            })}
                        </div>
                    </React.Fragment>
                )
            })}
        </>
    );
}

export default Match;